import {Form} from "../../../form/form";
import {GvfService} from "../../../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../../../gvf/js/gvf-ui-service";
import {UtilsService} from "../../../../js/utils-service";

export class DynamicFormFieldConditionForm extends Form{
    updateFilterFormFields(){
        GvfService.endpoint(
            "/cp/dynamic-form-field-detail/get-filter-value-form",
            {gid:this.$fieldGid.formFieldVal(),formData:this.$root.getValues()}
        ).then(
            (resp)=>{
                this.$root.find(".is-filter-form-field").remove();
                const $fields = $(resp.html).find(".js-form-field");
                $fields.insertAfter(this.$fieldGid);
                $fields.addClass("is-filter-form-field");
                GvfUiService.init($fields);
                this.checkBindings();
            }
        ).catch(UtilsService.alertEndpointResponse);
    }

    ready(){
        super.ready();
        this.$fieldGid = this.$root.findFormFieldByName("dynamicFormFieldGid");
        this.$fieldGid.on(
            "formField:changeVal",
            ()=>{
                this.updateFilterFormFields();
            }
        );
    }
}

